<section class="login-wrapper content-part" *ngIf="!loader.activeOther">
  <kendo-card style="border-radius: 10px;" class="p-24 text-center" [width]="'95%'">
    <img class="logo m-auto" src="assets/mobile-logo.svg" />
    <h2 class="mt-24 mb-24">Welcome back</h2>
    <p class="warning-message mb-24">Log in to NEFCO by clicking the button below</p>
    <button kendoButton themeColor="primary" fillMode="solid" size="medium" (click)="login()" #loginBtn
      type="button">Log in</button>
  </kendo-card>
</section>
